var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.baseInfo != null)?_c('div',{staticClass:"copyright"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("\n            All rights reserved by "+_vm._s(_vm.baseInfo.ShopName)+" Company.\n        ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }